import * as A from 'fp-ts/Array';
import { pipe } from 'fp-ts/function';
import * as O from 'fp-ts/Option';
export var hasCompletionsLeft = function hasCompletionsLeft(challenge) {
  return challenge.remainingCompletionCount === null || challenge.remainingCompletionCount > 0;
};
export var hasMemberCompletionsLeft = function hasMemberCompletionsLeft(challenge) {
  return challenge.memberRemainingCompletionCount === null || challenge.memberRemainingCompletionCount > 0;
};
export var isInProgress = function isInProgress(a) {
  return a.state !== 'rejected' && a.state !== 'closed';
};
export var isSingleCompleteNotStarted = function isSingleCompleteNotStarted(challenge) {
  return !challenge.multiComplete && !challenge.inProgress;
};
export var isMultiCompleteAvailable = function isMultiCompleteAvailable(challenge) {
  return challenge.multiComplete && hasCompletionsLeft(challenge) && hasMemberCompletionsLeft(challenge);
};
export function getCurrentActivity(challenge) {
  return pipe(challenge.activities, O.fromNullable, O.chain(O.fromPredicate(A.isNonEmpty)), O.matchW(function () {
    return isSingleCompleteNotStarted(challenge) ? O.some(null) : O.none;
  }, A.findLast(isInProgress)), O.altW(function () {
    return isMultiCompleteAvailable(challenge) ? O.some(null) : O.none;
  }), O.altW(function () {
    return pipe(challenge.activities, O.fromNullable, O.chain(A.last));
  }), O.matchW(function () {
    return {
      _tag: 'cannot-start'
    };
  }, function (activity) {
    return activity == null ? {
      _tag: 'can-start'
    } : {
      _tag: 'can-continue',
      activity: activity
    };
  }));
}